// extracted by mini-css-extract-plugin
module.exports = {"root":"SliderList_root__QmCfM","right":"SliderList_right__y10jr","rightSticky":"SliderList_rightSticky__bCf0G","rightTriggers":"SliderList_rightTriggers__d9r7H"};